const pagesPersonCertificationEn = {
  status: {
    ACTIVE: "Active",
    APPLYING: "Applying",
    EXPIRED: "Expired",
    SUSPENDED: "Suspended",
    REVOKED: "Revoked",
  },
  detail: {
    tabs: {
      detail: "Detail",
    },
    body: {
      errors: {
        dataLoadFailed: "Failed to load data",
        unknownError: "An unknown error occurred",
        certificationNotFound: "Person certification details not found",
        certificationIdLabel: "Person certification ID: {{id}}",
      },
    },
  },
};

export default pagesPersonCertificationEn;
